import { useState } from "react";
import LoginPage from "@/pages/admin/components/LoginPage";
import PartnersTab from "@/pages/admin/components/PartnersTab";
import GuaranteeTab from "@/pages/admin/components/GuaranteeTab";
import ActivityTab from "@/pages/admin/components/ActivityTab";
import SettingsTab from "@/pages/admin/components/SettingsTab";
import ChangePasswordTab from "@/pages/admin/components/ChangePasswordTab";
import SyncStatusBar from "@/pages/admin/components/SyncStatusBar";

type TabKey = "partners" | "guarantee" | "activity" | "settings" | "password";

const TABS = [
  { key: "partners", label: "商务人员", icon: "ri-group-line" },
  { key: "guarantee", label: "担保记录", icon: "ri-shield-check-line" },
  { key: "activity", label: "活动专栏", icon: "ri-megaphone-line" },
  { key: "settings", label: "站点设置", icon: "ri-settings-3-line" },
  { key: "password", label: "修改密码", icon: "ri-lock-password-line" },
] as const;

export default function AdminPage() {
  const [token, setToken] = useState(() => localStorage.getItem("hx_admin_token") || "");
  const [tab, setTab] = useState<TabKey>("partners");

  const handleLogout = () => {
    localStorage.removeItem("hx_admin_token");
    setToken("");
  };

  if (!token) return <LoginPage onLogin={setToken} />;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="w-full bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-orange-400">
              <span className="text-white font-black text-xs">HX</span>
            </div>
            <span className="text-sm font-bold text-gray-800">合盈后台管理</span>
          </div>
          <div className="flex items-center gap-3">
            <a href="/" className="text-xs text-gray-400 hover:text-gray-600 cursor-pointer whitespace-nowrap">
              <i className="ri-home-line mr-1"></i>前台
            </a>
            <button onClick={handleLogout} className="text-xs text-red-400 hover:text-red-600 cursor-pointer whitespace-nowrap">
              <i className="ri-logout-box-line mr-1"></i>退出
            </button>
          </div>
        </div>
      </header>

      {/* 数据库连接状态 */}
      <SyncStatusBar token={token} />

      {/* Tab 导航 */}
      <div className="w-full bg-white border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-4 flex gap-1 py-2 overflow-x-auto">
          {TABS.map(t => (
            <button key={t.key} onClick={() => setTab(t.key)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                tab === t.key ? "bg-red-50 text-red-500" : "text-gray-600 hover:bg-gray-50"
              }`}>
              <i className={`${t.icon} text-base`}></i>{t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab 内容 */}
      <div className="max-w-3xl mx-auto px-4 py-5">
        {tab === "partners" && <PartnersTab token={token} />}
        {tab === "guarantee" && <GuaranteeTab token={token} />}
        {tab === "activity" && <ActivityTab token={token} />}
        {tab === "settings" && <SettingsTab token={token} />}
        {tab === "password" && <ChangePasswordTab token={token} onLogout={handleLogout} />}
      </div>
    </div>
  );
}
